<template>
  <div>
    <el-drawer
      title="Offer Recommended"
      :append-to-body="append_body"
      @open="getOfferRecommend"
      size="60%"
      custom-class="create-smart-link"
      :visible.sync="drawerStatus"
      :before-close="handleDrawerClose"
      direction="rtl"
      ref="drawer"
    >
      <!-- Offer Setting -->
      <section class="mt-3">
        <el-row justify="space-between">
          <el-col :span="20">
            <p>
              Belows are offers which best match your selected creative and sort by ecpm , you can
              select them in the prior list.
            </p>
          </el-col>
          <el-col :span="4" class="right">
            <el-button class="xlong-button" type="primary" @click="getOfferRecommend">
              <i class="icon-y-shuaxin mr-2"></i>
              Change
            </el-button>
          </el-col>
        </el-row>
        <el-table
          class="mt-2 recommend-list"
          ref="offerList2"
          empty-text="No Data"
          :fit="true"
          border
          :data="recommend.filter_list"
          v-loading="drawer_loading"
        >
          <el-table-column label="Icon" width="72">
            <template slot-scope="scope">
              <img :src="scope.row.icon_url" class="icon" alt="icon" :onerror="defaultImg" />
            </template>
          </el-table-column>
          <el-table-column label="Offer" show-overflow-tooltip min-width="300px">
            <template slot-scope="scope">
              {{ '(' + scope.row.oid + ')' + scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column prop="payout_price" label="Payout($)"></el-table-column>
          <el-table-column label="Action" width="150px">
            <template slot-scope="scope">
              <el-button
                class="long-button"
                type="success"
                @click="applyOffer(scope.row)"
                v-if="scope.row.approve_status != 1"
              >
                Apply
              </el-button>
              <el-button
                v-else
                class="long-button"
                type="success"
                @click="moveOffer('recommend', 'prior', '', { list: [scope.row] })"
              >
                Select
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </section>

      <!-- Prior Setting -->
      <section class="mt-2 prior-list">
        <div class="non-divider">
          <h3 class="mr-2">Prior Offers</h3>
          <p>Traffic will be distributed to the offers according to your setting.</p>
        </div>
        <el-radio-group v-model="active">
          <el-card
            class="pointer prior-option mr-3"
            :class="{ 'selected-card': active === 'scope' }"
          >
            <el-radio label="scope">Set the scope</el-radio>
            <el-tooltip
              enterable
              content="All traffic will be sent to your prior offers."
              placement="top"
            >
              <i class="icon-y-question"></i>
            </el-tooltip>
          </el-card>
          <el-card
            class="pointer prior-option mr-3"
            :class="{ 'selected-card': active === 'weight' }"
          >
            <el-radio label="weight">Set weight</el-radio>
            <el-tooltip
              enterable
              content="Distribute the traffic based on the weight setting. If an offer has a weight of 80, it will receive 80% of the targeting traffic."
              placement="top"
            >
              <i class="icon-y-question"></i>
            </el-tooltip>
          </el-card>
        </el-radio-group>
        <div v-if="active === 'scope'">
          <el-form :rules="rules" :model="offer_ratio" ref="prior_form2">
            <el-table
              class="mt-5"
              ref="priorOffer2"
              empty-text="No Data"
              :fit="true"
              border
              :data="prior.show_list"
            >
              <el-table-column type="selection" width="42" show-overflow-tooltip></el-table-column>
              <el-table-column label="Icon" width="72">
                <template slot-scope="scope">
                  <img :src="scope.row.icon_url" class="icon" alt="icon" :onerror="defaultImg" />
                </template>
              </el-table-column>
              <el-table-column label="Offer" show-overflow-tooltip min-width="300px">
                <template slot-scope="scope">
                  {{ '(' + scope.row.oid + ')' + scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="payout_price" label="Payout($)" width="90px"></el-table-column>
              <el-table-column label="Action" width="150px" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    class="long-button"
                    type="danger"
                    @click="moveOffer('prior', 'recommend', '', { list: [scope.row] })"
                  >
                    Delete
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <el-row type="flex" justify="space-between" class="mt-2">
            <el-col :xs="12" :sm="12" :md="12">
              <el-button
                class="long-button"
                type="danger"
                @click="moveOffer('prior', 'recommend', '', { form: 'priorOffer2' })"
              >
                Delete
              </el-button>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12">
              <el-pagination
                class="right"
                @current-change="priorPagination"
                :page-size.sync="prior.pageInfo.per"
                :current-page.sync="prior.pageInfo.cur"
                layout="prev, pager, next"
                :total="prior.pageInfo.tot"
              ></el-pagination>
            </el-col>
          </el-row>
          <el-row v-if="error_tip" type="flex" justify="end" class="right mt-1">
            <el-col :xs="12" :sm="12" :md="12">
              <p class="error_tip">
                value error in other page
              </p>
            </el-col>
          </el-row>
        </div>
        <div v-if="active === 'weight'">
          <div>
            <p class="mr-2">The ratio of clicks to prior offers (Between 1 and 100):</p>
            <el-tooltip
              enterable
              content="The algorithm will just send the ratio of traffic you set to the prior offers."
              placement="top"
            >
              <i class="icon-y-question"></i>
            </el-tooltip>
          </div>
          <el-input-number
            class="mr-2"
            v-model="prior_ratio"
            controls-position="right"
            :min="1"
            :max="100"
          ></el-input-number>
          <el-form :rules="rules" :model="offer_ratio" ref="prior_form2">
            <el-table
              class="mt-5"
              ref="priorOffer2"
              empty-text="No Data"
              :fit="true"
              border
              :data="prior.show_list"
            >
              <el-table-column type="selection" width="42" show-overflow-tooltip></el-table-column>
              <el-table-column label="Icon" width="72">
                <template slot-scope="scope">
                  <img :src="scope.row.icon_url" class="icon" alt="icon" :onerror="defaultImg" />
                </template>
              </el-table-column>
              <el-table-column label="Offer" show-overflow-tooltip min-width="300px">
                <template slot-scope="scope">
                  {{ '(' + scope.row.oid + ')' + scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="payout_price" label="Payout($)" width="90px"></el-table-column>
              <el-table-column width="200px">
                <template slot="header">
                  Weight Ratio(%)
                  <el-tooltip
                    enterable
                    content="The  algorithm sends the traffic according to prior offer's weight. Suggest to set the below offer's weight between 1 and 100."
                    placement="top"
                  >
                    <i class="icon-y-question"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-form-item class="ratio" :prop="String(scope.row.oid)" :rules="rules.ratio">
                    <el-input v-model="offer_ratio[scope.row.oid]"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="Action" width="150px" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    class="long-button"
                    type="warning"
                    @click="moveOffer('prior', 'recommend', '', { list: [scope.row] })"
                  >
                    Delete
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <el-row type="flex" justify="space-between" class="mt-2">
            <el-col :xs="12" :sm="12" :md="12">
              <el-button
                class="long-button"
                type="warning"
                @click="moveOffer('prior', 'recommend', '', { form: 'priorOffer2' })"
              >
                Delete
              </el-button>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12">
              <el-pagination
                class="right"
                @current-change="priorPagination"
                :page-size.sync="prior.pageInfo.per"
                :current-page.sync="prior.pageInfo.cur"
                layout="prev, pager, next"
                :total="prior.pageInfo.tot"
              ></el-pagination>
            </el-col>
          </el-row>
          <el-row v-if="error_tip" type="flex" justify="end" class="right mt-1">
            <el-col :xs="12" :sm="12" :md="12">
              <p class="error_tip">
                value error in other page
              </p>
            </el-col>
          </el-row>
        </div>
      </section>

      <div class="drawer_bottom center">
        <el-button @click="closeDrawer" class="long-button">
          Back
        </el-button>
      </div>
    </el-drawer>
    <apply-offer
      v-if="show"
      :show.sync="show"
      :detailApply="detailApply"
      @cancel="show = false"
      @apply="applyCb"
    ></apply-offer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import applyOffer from '@/page/offers/applyOffer.vue'
export default {
  data() {
    return {
      defaultImg: 'this.src="' + require('../../assets/img/offer-icon.png') + '"',
      drawer_loading: false,
      error_tip: false,
      show: false,

      drawerStatus: this.drawer,
      prior_ratio: 80,
      detailApply: {},
      recommend: {
        list: [],
        filter_list: [],
        pageInfo: {
          cur: 0,
          per: 10,
          tot: 0,
        },
      },
      normal: {
        list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      prior: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      blocked: {
        list: [],
        filter_list: [],
        show_list: [],
        pageInfo: {
          cur: 1,
          per: 10,
          tot: 0,
        },
      },
      rules: {
        name: [{ required: true, message: 'Can\'t be empty!', trigger: 'change' }],
        ratio: [
          {
            validator: this.validateRatio,
            trigger: 'blur',
          },
          { required: true, message: 'Can\'t be empty!', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    drawer(val) {
      this.drawerStatus = val
    },
  },
  props: {
    getOfferList_: {
      type: Function,
      default() {
        return () => {}
      },
    },
    active: {
      type: String,
      default() {
        return 'scope'
      },
    },
    drawer: {
      type: Boolean,
      default() {
        return false
      },
    },
    append_body: {
      type: Boolean,
      default() {
        return false
      },
    },
    offer_ratio: {
      type: Object,
      default() {
        return {}
      },
    },
    select_creative: {
      type: Object,
      default() {
        return {}
      },
    },
    sml_link: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    closeDrawer() {
      this.$refs.drawer.closeDrawer()
    },
    applyCb() {
      this.detailApply.offer.approve_status = 0
      this.detailApply.offer.status = 0
      this.show = false
    },
    handleDrawerClose(done) {
      let valid2 = false
      this.$refs['prior_form2'].validate(valid => {
        valid2 = valid
      })
      if (valid2) {
        this.$emit('drawer', false)
        done()
      } else {
        return
      }
      this.recommend = {
        list: [],
        pageInfo: {
          cur: 0,
          per: 10,
          tot: 0,
        },
      }
    },
    getOfferRecommend() {
      if (this.recommend.list.length) {
        if (this.recommend.pageInfo.cur++ >= this.recommend.list.length / 10) {
          this.recommend.pageInfo.cur = 0
        }
        this.recommend.filter_list = this.recommend.list.slice(
          this.recommend.pageInfo.per * this.recommend.pageInfo.cur,
          this.recommend.pageInfo.per * (this.recommend.pageInfo.cur + 1)
        )
        return
      }

      this.drawer_loading = true
      this.$http
        .get('/api/offers/get-recommend-offers/', {
          params: {
            country: this.creative_country,
            name: this.select_creative.name,
            category: this.select_creative.category
              ? [this.select_creative.category]
              : this.creative_category,
            restriction_type: this.select_creative.stream_type,
            offer_type: this.select_creative.offer_type,
            p: ++this.recommend.pageInfo.cur || 1,
            n: this.recommend.pageInfo.per,
          },
        })
        .then(res => {
          this.recommend.list = res.data
          this.recommend.filter_list = this.recommend.list.slice(0, this.recommend.pageInfo.per)
          this.drawer_loading = false
        })
        .catch(error => {
          this.drawer_loading = false
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
    priorPagination(page_current) {
      this.customPagination(page_current, this.prior)
    },
    customPagination(page_current, table) {
      let filter_list = table.filter_list
      let pageInfo = table.pageInfo
      let per_page = pageInfo.per
      let start_index = (page_current - 1) * per_page

      pageInfo.cur = page_current
      pageInfo.tot = filter_list.length
      filter_list.forEach(item => {
        item.ratio = 0
      })
      table.show_list = [...filter_list.slice(start_index, start_index + per_page)]
    },
    moveOffer(from, to, parent, params) {
      parent = this
      let list = params.list || this.$refs[params.form].selection
      if (!list.length) {
        return
      }
      let parent_to = parent[to]
      let parent_from = parent[from]
      if (from === 'recommend') {
        let offer = list[0]
        for (let i = 0; i < parent_to.list.length; i++) {
          let item = parent_to.list[i]
          if (Number(item.oid) === Number(offer.oid)) {
            return
          }
        }
      }

      parent_from.list = this.subArg(parent_from.list, list, 'oid')
      if (to === 'recommend') {
        let diffence = []
        for (let k = 0; k < list.length; k++) {
          let diff_item = list[k]
          for (let i = 0; i < parent_to.list.length; i++) {
            let item = parent_to.list[i]
            if (diff_item.oid === Number(item.oid)) {
              diffence.push(diff_item)
            }
          }
        }

        let cut = list.concat(diffence).filter(v => !list.includes(v) || !diffence.includes(v))
        parent_to.list = cut.concat(parent_to.list)
      } else {
        parent_to.list = list.concat(parent_to.list)
      }
      if (to !== 'normal' && to !== 'recommend') {
        parent_to.filter_list = list.concat(parent_to.filter_list)
        this.customPagination(parent_to.pageInfo.cur, parent_to)
      } else {
        parent_to.pageInfo.tot += list.length
        this.filled_oid = list[0] ? list[0].oid : 0
      }
      if (from !== 'normal' && from !== 'recommend') {
        if (from === 'prior') {
          list.forEach(item => {
            // this.$delete(this.offer_ratio, item.oid)
            delete this.offer_ratio[item.oid]
          })
        }
        parent_from.filter_list = this.subArg(parent_from.filter_list, list, 'oid')
        if (list.length === parent_from.show_list.length && parent_from.pageInfo.cur > 1) {
          parent_from.pageInfo.cur--
        }
        this.customPagination(parent_from.pageInfo.cur, parent_from)
      } else {
        parent_from.pageInfo.tot -= list.length

        if (parent_from.list.length <= 0) {
          this.filled_oid = 0
          this.getOfferList_()
        }
      }

      if (params.form) {
        this.$refs[params.form].clearSelection()
      }
      if (to === 'prior') {
        list.forEach(item => {
          this.$set(this.offer_ratio, item.oid, 10)
        })
      }
    },
    applyOffer(offer) {
      if (this.settings.user.status === 0) {
        this.updateInfo(this.$route.path)
        return
      }
      this.detailApply = {
        offer: offer,
        channel_list: this.channel_list,
        aid: this.aid,
        link_type: 1,
      }

      this.show = true
    },
    validateRatio(rule, value, callback) {
      let prior_list = this.offer_ratio
      let tot = 0
      this.error_tip = false
      for (let i in prior_list) {
        tot += Number(prior_list[i])
        if (Number(prior_list[i]) === 0) {
          let in_show_list = false
          for (let k = 0; k < this.prior.show_list.length; k++) {
            if (this.prior.show_list[k].oid === i) {
              in_show_list = true
            }
          }
          if (!in_show_list) {
            this.error_page = i
            this.error_tip = true
          }
        }
      }
      if (isNaN(Number(value))) {
        callback(new Error('please enter a valid number!'))
      } else if (value % 1 !== 0) {
        callback(new Error('please enter an Integer'))
      } else if (Number(value) > 100 || Number(value <= 0)) {
        callback(new Error('0< ratio <= 100'))
      } else if (Number(tot) > 100) {
        callback(new Error('weights shouldn\'t more than 100.'))
      } else if (this.error_tip) {
        callback(new Error(' '))
      } else {
        this.error_tip = false
        callback()
      }
    },
  },
  components: {
    applyOffer,
  },
}
</script>
